module.exports = __webpack_public_path__ + "static/media/carro_3.ced5e738.webp";